export default __webpack_public_path__ + "static/media/a2.b1104e3c.png";